import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import axios from "axios";
import Tabletop from 'tabletop';
import moment from 'moment';
import Rellax from "rellax";
import { SRLWrapper } from 'simple-react-lightbox';

import Audio from '../../components/audio';
import Covidmodal from '../../components/covidModal';
import QrCodeGenerator from "../scanner/qrCodeGenerator";

let guestName = "";
let kepada = "";
let params = "";
let dark = "";
const gbUrl = "https://sheet.best/api/sheets/a823445a-2a20-43cf-a190-feac621d6e6a";
const gbKey = "1rZRorURk7H_u8IC_z-kRx62H22qqLr8Ewt1K_hGhX_k";


function YuniRiki() {
    const [gbName, setGbName] = useState("");
    const [gbPhone, setGbPhone] = useState("-");
    const [gbAtt, setGbAtt] = useState("");
    const [gbPerson, setGbPerson] = useState("0")
    const [gbMsg, setGbMsg] = useState("");
    const [gbDisable, setGbDisable] = useState(false);
    const [gbSent, setGbSent] = useState(false);
    const [showGbMsg, setShowGbMsg] = useState(false);
    const [gbMsgList, setGbMsgList] = useState([]);
    const [gbWaiting, setGbWaiting] = useState(false);
    const [showQrCode, setShowQrCode] = useState(false);

    useEffect(() => {
        new Rellax(".rellax", {})
    })
    const requestGuestBook = (() => {
        Tabletop.init({
            key: gbKey,
            callback: googleData => {
                let data = googleData;
                if ("Guestbook" in data) {
                    data = data["Guestbook"].elements;
                    data.reverse();
                    setGbMsgList(data);
                    setGbWaiting(false);
                }
            },
            simpleSheet: false
        })
    })

    useState(() => {
        let search = window.location.search;
        params = new URLSearchParams(search);

        kepada = params.get('kepada');
        dark = params.get("dark");
        if (kepada != null) guestName = "Kepada Yth. \n" + kepada;
        if (kepada != null) setShowQrCode(true);
    })

    const messageList = gbMsgList.map((data, id) => {
        return <div key={id}>
            <div className="comment-item">
                <p className="comment-name">{data.name} <span className="comment-time"> &nbsp; — &nbsp; <i className="fa fa-clock-o"></i> &nbsp; {moment(data.date).fromNow()}</span></p>
                <p className="comment-message">{data.message}</p>
            </div>
        </div>
    })


    const gbSubmitHandler = ((e) => {
        e.preventDefault();
        setGbDisable(true);
        const payload = {
            date: new Date(),
            name: gbName,
            phone: gbPhone,
            attendance: gbAtt,
            person: gbPerson,
            message: gbMsg
        }

        axios.post(gbUrl, payload)
            .then(response => {
                setGbDisable(false);
                setGbSent(true);
            })
    })

    return (
        <>
            <Helmet>
                <title>The Wedding of Yuni &amp; Riki</title>
                <meta name="description" content="We invite you to celebrate our wedding!" />
                <meta property="og:image" content="%PUBLIC_URL%/logo192.png" />
                <link href="/assets/global/header-cta.css" rel="stylesheet" />
                <link rel="stylesheet" href="/assets/global/animation.css" />
                <script src="/assets/global/animation.js"></script>
                <link href="/assets/clients/yuniriki/css/main.css" rel="stylesheet" />
                {/* {
                    (dark != null) ?
                        <link href="/assets/clients/yuniriki/css/main-dark.css" rel="stylesheet" />
                        :
                } */}
                <script src="/assets/global/countdown.js" date="2021-07-02 16:00"></script>
                <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Great+Vibes&amp;display=swap" />
                <link href="https://fonts.googleapis.com/css2?family=Shippori+Mincho+B1" rel="stylesheet" />
                <link href="https://fonts.googleapis.com/css2?family=Dawning+of+a+New+Day&display=swap" rel="stylesheet" />
                {/* <link href="/assets/clients/yuniriki/css/font-awesome/css/all.min.css" rel="stylesheet" /> */}
                <link rel="stylesheet" href="/assets/global/fa.css" />
                <link href="/assets/clients/yuniriki/css/bootstrap.css" rel="stylesheet" />
                {/* {
                    (dark != null) ?
                        <link href="/assets/clients/yuniriki/css/bootstrap-dark.css" rel="stylesheet" />
                        :
                } */}
                <link rel="stylesheet" href="https://cdn.linearicons.com/free/1.0.0/icon-font.min.css" />
                <script src="/assets/global/cursor.js"></script>
                <link href="/assets/global/cursor.css" rel="stylesheet" />

                <link rel="stylesheet" href="/assets/template/artavika/css/vendor.css" />

                <script src="https://cdn.jsdelivr.net/npm/simple-parallax-js@5.5.1/dist/simpleParallax.min.js"></script>
            </Helmet>
            <Audio music="Cécile_Ensemble_-_Married_Life_(from_Pixar's_movie_Up).mp3" />
            {/* <Covidmodal /> */}
            <div className="cursor"></div>
            <main className="page-content">
                <section className="ww-home-page" id="home">
                    <div className="ww-wedding-announcement d-flex align-items-center justify-content-start">
                        <div className="container ww-announcement-container">
                            <p animation-delay="200" animation-type="fadeInUp" className="wedding-of">The Wedding Of</p>
                            <p animation-delay="400" animation-type="fadeInUp" className="ww-couple-name">Yuni & Riki</p>
                            <p animation-delay="600" animation-type="fadeInUp" className="kepada">{guestName}</p><br /><br />
                            {/* <p><strong>Sabtu, 1 Januari 2022</strong></p> */}
                        </div>
                        <div className="custom-shape-divider-bottom" style={{ "transform": "scaleY(-1) scaleX(-1)" }}>
                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                                <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
                            </svg>
                        </div>
                    </div>
                </section>
                <section className="ww-section bg-dark" id="couple">
                    <div className="container first-container">
                        <p className="text-center"><img animation-delay="800" animation-type="fadeInDown" src="assets/clients/yuniriki/images/divider-flip.png" className="divider" alt="Separator" /></p>
                        <h2 animation-delay="400" animation-type="zoomIn" className="h1 text-center pb-3 ww-title" >
                            <span animation-delay="300" animation-type="zoomIn" >Kami yang Berbahagia</span>
                        </h2>
                        <p className="text-center"><img animation-delay="400" animation-type="fadeInUp" src="assets/clients/yuniriki/images/divider.png" className="divider" alt="Separator" /></p>
                        <br />&nbsp;
                        <div className="row text-center">
                            <div className="col-md-6">
                                <div className="mt-3"><img animation-delay="400" animation-type="zoomIn" className="img-fluid wedding-person" src="assets/clients/yuniriki/images/bride.jpg" alt="Bride" />

                                    <br />&nbsp;
                                    <h3 animation-delay="600" animation-type="fadeInUp" className="h2 ww-title">Yuniasri Maya Aisyah</h3>
                                    <p animation-delay="1200" animation-type="zoomIn" className="pt-3 text-center text-muted">Putri kedua dari<br /><em><strong>Bp. Kusmayadi & Ibu Sri Suwarsi</strong></em><br />Komplek Saba Utama blok C1 no 11, Ciparigi, Bogor</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mt-3"><img animation-delay="400" animation-type="zoomIn" className="img-fluid wedding-person" src="assets/clients/yuniriki/images/groom.jpg" alt="Groom" />
                                    <br />&nbsp;
                                    <h3 animation-delay="400" animation-type="fadeInUp" className="h2 ww-title">Riki Mulyo Indriawan</h3>
                                    <p animation-delay="800" animation-type="zoomIn" className="pt-3 text-center text-muted">Putra pertama dari<br /><em><strong>Bp. Mulyono (Alm.) & Ibu Indaryati</strong></em><br />Jalan Raya Muntal RT 002/004, Mangunsari, Gunung Pati, Semarang</p>
                                </div>
                            </div>
                        </div>
                        &nbsp;
                        <p className="text-center"><img animation-delay="1200" animation-type="zoomIn" src="assets/clients/yuniriki/images/grass.png" className="" alt="Separator" /></p>
                        <div className="width-limiter">
                            <p animation-delay="300" animation-type="rotateInUpRight" className="pt-5 text-center text-muted prayer">Dan Allah menjadikan bagimu pasangan (suami atau istri) dari jenis kamu sendiri, menjadikan anak dan cucu bagimu dari pasanganmu, serta memberimu rezeki dari yang baik-baik. Mengapa mereka beriman kepada yang batil dan mengingkari nikmat Allah?</p>
                            <p animation-delay="600" animation-type="rotateInUpLeft" className="ww-title text-center">QS An-Nahl 72</p>
                        </div>
                    </div>
                </section>
                <div className="sidewinder-wrapper-left">
                    <img className="rellax sidewinder" data-rellax-speed="7" alt="sider" src="assets/clients/yuniriki/images/sidewinder.png" />
                </div>
                <div className="sidewinder-wrapper-right">
                    <img className="rellax sidewinder" data-rellax-speed="7" alt="sider" src="assets/clients/yuniriki/images/sidewinder-right.png" />
                </div>
                <div class="svg-divider-triangle-bottom">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
                    </svg>
                </div>
                <section className="ww-section bg-light" id="events">
                    <div className="container ww-wedding-event">
                        <p animation-delay="400" animation-type="fadeInUp" className="pt-4 text-center text-muted width-limiter">Dengan menyebut nama Tuhan Yang Maha Esa, kami bermaksud mengundang Bapak/Ibu/Saudara/i pada resepsi pernikahan kami yang akan diselenggarakan pada:</p>
                        <br />
                        <br />
                        <br />
                        <p animation-delay="300" animation-type="fadeInDown" className="h2 text-center ww-sub-title">Akad:</p><br />
                        <p animation-delay="300" animation-type="fadeInDown" className="h4 text-center ww-sub-title">Jumat</p>
                        <p animation-delay="300" animation-type="fadeInDown" className="h3 text-center ww-sub-title">2 / Juli / 2021</p>
                        <p animation-delay="300" animation-type="zoomIn" className="text-center"><img src="assets/clients/pipinyolan/images/grass.png" className="event-separator" alt="Separator" /></p>
                        <p animation-delay="300" animation-type="zoomIn" className="h3 text-center ww-sub-title">16:00 - 18:00</p>
                        <p animation-delay="300" animation-type="fadeInUp" className="text-center"><img src="assets/clients/pipinyolan/images/grass.png" className="event-separator" alt="Separator" /></p>
                        <p animation-delay="300" animation-type="fadeInUp" className="h4 text-center ww-sub-title">Van Hoeis Bogor</p>
                        <br />
                        <br />
                        <hr />
                        <br />
                        <p animation-delay="300" animation-type="fadeInDown" className="h2 text-center ww-sub-title">Resepsi:</p><br />
                        <p animation-delay="300" animation-type="fadeInDown" className="h4 text-center ww-sub-title">Minggu</p>
                        <p animation-delay="300" animation-type="fadeInDown" className="h3 text-center ww-sub-title">18 / Juli / 2021</p>
                        <p animation-delay="300" animation-type="zoomIn" className="text-center"><img src="assets/clients/pipinyolan/images/grass.png" className="event-separator" alt="Separator" /></p>
                        <p animation-delay="300" animation-type="zoomIn" className="h3 text-center ww-sub-title">10:00 - 12:00</p>
                        <p animation-delay="300" animation-type="fadeInUp" className="text-center"><img src="assets/clients/pipinyolan/images/grass.png" className="event-separator" alt="Separator" /></p>
                        <p animation-delay="300" animation-type="fadeInUp" className="h4 text-center ww-sub-title">Kediaman Mempelai Pria</p>
                        <br />
                        <br />
                        <small animation-delay="300" animation-type="fadeInUp" className="pt-4 text-center text-muted width-limiter">Tanpa mengurangi rasa hormat sedikit pun, acara resepsi pernikahan akan dilakukan dengan tetap mengikuti protokol kesehatan sesuai anjuran pemerintah.</small>
                        <br />&nbsp;
                        {
                            (showQrCode) ?
                                <>
                                    <hr />
                                    <QrCodeGenerator
                                        value={kepada}
                                        bgColor="#ffffff"
                                        fgColor="#000000"
                                        size={256}
                                        fontColor="#ababab"
                                    />
                                    <hr />
                                </>
                                : null
                        }
                    </div>
                </section>
                <div class="svg-divider-triangle-bottom" style={{ "transform": "scaleY(-1)" }}>
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
                    </svg>
                </div>
                <section className="ww-section bg-dark" id="people">
                    <div className="container text-center">
                        <p animation-delay="400" animation-type="fadeInUp" className="text-center"><img src="assets/clients/yuniriki/images/divider-flip.png" className="divider" alt="Separator" /></p>
                        <h2 animation-delay="400" animation-type="zoomIn" className="h1 text-center pb-3 ww-title" >Lokasi Akad</h2>
                        <p animation-delay="400" animation-type="fadeInDown" className="text-center"><img src="assets/clients/yuniriki/images/divider.png" className="divider" alt="Separator" /></p>
                        <p animation-delay="400" animation-type="fadeInUp" className="pt-4 text-center text-muted width-limiter">Silakan gunakan peta di bawah ini untuk mencari rute terdekat ke lokasi akad kami.</p>
                        <br />
                        <iframe animation-delay="400" animation-type="zoomIn" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.267370236778!2d106.80597781477113!3d-6.613665695217334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69c557852e9415%3A0x959ef307ed89395c!2sVan%20Hoeis%20Bogor!5e0!3m2!1sen!2sid!4v1622078539450!5m2!1sen!2sid" width="90%" height="600" style={{ "border": "0;", }} allowfullscreen="" loading="lazy" title="Wedding Location" className="maps-embed"></iframe>
                        <br />
                        <br />
                        <a animation-delay="200" animation-type="zoomInUp" className="gb-btn" href="https://goo.gl/maps/2gUuMpM4gfJTEoSr8" target="_blank" rel="noreferrer"><i className="fa fa-map-marker"></i> &nbsp; Cek Petunjuk Arah</a>
                    </div>
                    <br />
                    <br />
                    <br />
                    <hr />
                    <br />
                    <br />
                    <br />
                    <div className="container text-center">
                        <p animation-delay="400" animation-type="fadeInUp" className="text-center"><img src="assets/clients/yuniriki/images/divider-flip.png" className="divider" alt="Separator" /></p>
                        <h2 animation-delay="400" animation-type="zoomIn" className="h1 text-center pb-3 ww-title" >Lokasi Resepsi</h2>
                        <p animation-delay="400" animation-type="fadeInDown" className="text-center"><img src="assets/clients/yuniriki/images/divider.png" className="divider" alt="Separator" /></p>
                        <p animation-delay="400" animation-type="fadeInUp" className="pt-4 text-center text-muted width-limiter">Silakan gunakan peta di bawah ini untuk mencari rute terdekat ke lokasi resepsi kami.</p>
                        <br />
                        <iframe animation-delay="400" animation-type="zoomIn" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3959.4299471196387!2d110.38571331477372!3d-7.076048994889598!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e708972561d2853%3A0x55cc351f00178e!2sMulyo%20Motor!5e0!3m2!1sen!2sid!4v1622078624797!5m2!1sen!2sid" width="90%" height="600" style={{ "border": "0;" }} allowfullscreen="" loading="lazy" title="Wedding Location" className="maps-embed"></iframe>
                        <br />
                        <br />
                        <a animation-delay="200" animation-type="zoomInUp" className="gb-btn" href="https://goo.gl/maps/nQBgzB2jf4hgifEe8" target="_blank" rel="noreferrer"><i className="fa fa-map-marker"></i> &nbsp; Cek Petunjuk Arah</a>
                    </div>
                </section>
                <div class="svg-divider-triangle-bottom" style={{ "transform": "scaleX(-1)" }}>
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
                    </svg>
                </div>
                <section className="ww-section bg-light" id="people">
                    <div className="container text-center">

                        <p animation-delay="400" animation-type="fadeInDown" className="text-center"><img src="assets/clients/yuniriki/images/divider.png" className="divider flip-divider" alt="Separator" /></p>
                        <p animation-delay="400" animation-type="zoomIn" className="h1 ww-title text-center">Menuju Hari Bahagia</p>
                        <p animation-delay="400" animation-type="fadeInUp" className="text-center"><img src="assets/clients/yuniriki/images/divider.png" className="divider" alt="Separator" /></p>
                        <p animation-delay="400" animation-type="fadeInUp" className="pt-4 text-center text-muted width-limiter">Merupakan suatu kehormatan dan kebahagiaan bagi kami jika Bapak/Ibu/Saudara/i berkenan untuk hadir pada acara ini.</p>
                        <ul className="countdown text-muted">
                            <li animation-delay="200" animation-type="zoomIn" ><span id="days"></span>hari</li>
                            <li animation-delay="400" animation-type="zoomIn" ><span id="hours"></span>jam</li>
                            <li animation-delay="600" animation-type="zoomIn" ><span id="minutes"></span>menit</li>
                            <li animation-delay="800" animation-type="zoomIn" ><span id="seconds"></span>detik</li>
                        </ul>
                    </div>
                </section>
                <div class="svg-divider-triangle-bottom" style={{ "transform": "scaleY(-1)" }}>
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
                    </svg>
                </div>
                <div className="sidewinder-wrapper-left">
                    <img className="rellax sidewinder" data-rellax-speed="7" alt="sider" src="assets/clients/yuniriki/images/sidewinder.png" />
                </div>
                <div className="sidewinder-wrapper-right">
                    <img className="rellax sidewinder" data-rellax-speed="7" alt="sider" src="assets/clients/yuniriki/images/sidewinder-right.png" />
                </div>
                {/* <div class="svg-divider-triangle-bottom" style={{ "transform": "scaleX(-1)" }}>
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
                    </svg>
                </div> */}
                <div className="sidewinder-wrapper-left">
                    <img className="rellax sidewinder" data-rellax-speed="7" alt="sider" src="assets/clients/yuniriki/images/sidewinder.png" />
                </div>
                <div className="sidewinder-wrapper-right">
                    <img className="rellax sidewinder" data-rellax-speed="7" alt="sider" src="assets/clients/yuniriki/images/sidewinder-right.png" />
                </div>
                <section className="ww-section bg-dark" id="gallery">
                    <div className="ww-photo-gallery">
                        <div className="container">
                            <p className="text-center"><img src="assets/clients/yuniriki/images/divider.png" className="divider flip-divider" alt="Separator" /></p>
                            <div className="h1 text-center pb-3 ww-title" >Galeri</div>
                            <p className="text-center"><img src="assets/clients/yuniriki/images/divider.png" className="divider" alt="Separator" /></p>
                            <br />
                            <div className="ww-gallery" >
                                <div className="card-columns">
                                    <SRLWrapper>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_1.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_2.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_3.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_4.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_5.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_6.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_7.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_8.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_9.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_10.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_11.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_12.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_13.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/galeri_14.JPG" alt="Yuni &amp; Riki" /></div>
                                        <div animation-delay="400" animation-type="zoomIn" className="card"><img className="img-fluid gallery-pic" src="assets/clients/yuniriki/images/cover-desktop.JPG" alt="Yuni &amp; Riki" /></div>
                                    </SRLWrapper>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div class="svg-divider-triangle-bottom" style={{ "transform": "scaleX(-1)" }}>
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
                    </svg>
                </div>
                <div className="sidewinder-wrapper-left">
                    <img className="rellax sidewinder" data-rellax-speed="7" alt="sider" src="assets/clients/yuniriki/images/sidewinder.png" />
                </div>
                <div className="sidewinder-wrapper-right">
                    <img className="rellax sidewinder" data-rellax-speed="7" alt="sider" src="assets/clients/yuniriki/images/sidewinder-right.png" />
                </div>
                <section className="ww-section bg-light" id="gallery">
                    <div className="ww-photo-gallery">
                        <div className="gb-container">
                            <p className="text-center"><img src="assets/clients/yuniriki/images/divider.png" className="divider flip-divider" alt="Separator" /></p>
                            <div className="h1 text-center pb-3 ww-title" >RSVP & Guestbook</div>
                            <p className="text-center"><img src="assets/clients/yuniriki/images/divider.png" className="divider" alt="Separator" /></p>
                            <p animation-delay="400" animation-type="fadeInUp" className="pt-4 text-center text-muted width-limiter">Kami memohon kesediaannya untuk mengisi buku tamu di bawah ini 😊</p>

                            <br />
                            {
                                (gbSent) ?
                                    <>
                                        <br />
                                        <p className="text-muted text-center">Terima kasih telah berkenan untuk mengisi buku tamu kami 😊 <br />Jika sempat, kami akan membalas melalui nomor telp/WA yang sudah dimasukkan.</p>
                                    </>
                                    :
                                    <>

                                        <form onSubmit={((e) => gbSubmitHandler(e))}>
                                            <fieldset>
                                                <div >
                                                    <div >
                                                        <input animation-delay="300" animation-type="fadeInUp" disabled={gbDisable} onChange={((e) => setGbName(e.target.value))} className="gb-input" id="nameInput" name="nameInput" type="text" placeholder="Nama" required autoComplete="off" />
                                                    </div>
                                                </div>

                                                <div>
                                                    <div >
                                                        <input animation-delay="300" animation-type="fadeInUp" disabled={gbDisable} onChange={((e) => setGbPhone(e.target.value))} className="gb-input" id="phoneInput" name="phoneInput" type="text" placeholder="Telp/WA" autoComplete="off" />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div >
                                                        <select animation-delay="300" animation-type="fadeInUp" onChange={((e) => setGbAtt(e.target.value))} className="gb-input" required>
                                                            <option value="" disabled selected>Apakah bisa hadir?</option>
                                                            <option value="yes">Ya, hadir</option>
                                                            <option value="no">Maaf, tidak bisa hadir</option>
                                                            <option value="maybe">Belum tahu</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div >
                                                    {
                                                        (gbAtt === "yes") ?
                                                            <>
                                                                <select onChange={((e) => setGbPerson(e.target.value))} className="gb-input">
                                                                    <option value="1" selected>1 orang</option>
                                                                    <option value="2-4">2-4 orang</option>
                                                                    <option value=">5">{">"} 5 orang</option>
                                                                </select>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </div>

                                                <div >
                                                    <div >
                                                        <textarea animation-delay="300" animation-type="fadeInUp" disabled={gbDisable} onChange={((e) => setGbMsg(e.target.value))} className="gb-input" id="msgInput" name="msgInput" placeholder="Pesan untuk mempelai" required autoComplete="off"></textarea>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div >
                                                        <br />
                                                        <button animation-delay="300" animation-type="fadeInUp" disabled={gbDisable} id="singlebutton" className="gb-btn" name="singlebutton" type="submit">Kirim</button>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </form>
                                    </>
                            }
                            <div>
                                <br />&nbsp;
                                <button className="gb-btn"
                                    animation-delay="300" animation-type="fadeInUp"
                                    onClick={((e) => {
                                        e.preventDefault();
                                        setGbWaiting(true);
                                        setShowGbMsg(!showGbMsg);
                                        if (!showGbMsg) requestGuestBook();
                                    })} >{(showGbMsg) ? "Tutup" : "Lihat"} Semua Pesan</button>
                            </div>
                            {
                                (showGbMsg) ?
                                    <>
                                        {
                                            (gbWaiting) ?
                                                <>
                                                    <br />&nbsp;
                                                    <p className="text-muted" style={{ "textAlign": "center" }}>Mohon tunggu...</p>
                                                </>
                                                :
                                                <div className="gb-wrap">
                                                    {messageList}
                                                </div>
                                        }
                                    </>
                                    :
                                    <>
                                    </>
                            }
                        </div>
                    </div>
                </section>
                <div class="svg-divider-triangle-bottom" style={{ "transform": "scaleY(-1)" }}>
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
                    </svg>
                </div>
                <footer className="ww-footer bg-dark">
                    <div className="container text-center py-4">
                        <p className="my-0 text-muted">Premium Wedding Invitation by <a href="https://vanilatte.com/" alt="Vanilatte Wedding e-Invitation Service">Vanilatte.com</a></p>
                        &nbsp;
                    </div>
                </footer>
            </main>

        </>
    )
}

export default YuniRiki;
